import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector     : 'carded-fullwidth-page-scroll',
    templateUrl  : './fullwidth.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CardedFullwidthPageScrollComponent
{
    /**
     * Constructor
     */
    constructor()
    {
    }
}
